<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      permanent
      width="350"
      class="o-nav pa-5"
      app
      clipped
    >
      <div class="mx-3 mt-5 mb-4 font-weight-bold text-uppercase">
        <div>{{ routeTitle }}</div>
      </div>
      <v-list dense height="50">
        <v-list-item
          v-for="route in routeChildren"
          :key="route.name"
          :index="route.index"
          dense
        >
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon
                small
                :class="`mr-2 mb-2 ${
                  route.name === activeRoute
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`"
                >fas fa-circle fa-fw</v-icon
              >
              <router-link
                :to="{ name: route.name }"
                :class="`o-sectionLink ${
                  route.name === activeRoute ? 'o-nav--active' : 'o-nav'
                }`"
                :data-cy="`adminNav-${route.name}`"
                >{{ route.meta.title }}</router-link
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-container fluid class="px-12 py-5">
      <v-row>
        <v-col cols="6">
          <v-breadcrumbs class="ma-0 pa-0" :items="breadcrumbList">
            <template v-slot:item="{ item }">
              <router-link :to="item.to">{{ item.text }}</router-link>
            </template>
          </v-breadcrumbs>
          <h1 data-cy="adminLandingTitle">{{ routeTitle }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    activeRoute() {
      const {
        $route: { name },
      } = this;

      return name;
    },
    breadcrumbList() {
      const { $route } = this;
      const { matched, params } = $route;

      return matched.map(route => {
        const { meta, name } = route;
        let { breadcrumb } = meta;
        const { breadcrumbIsParam } = meta;

        if (breadcrumbIsParam) {
          breadcrumb = params[breadcrumb];
        }

        if (!breadcrumb) {
          breadcrumb = "...";
        }

        return {
          text: breadcrumb,
          to: { name, params },
        };
      });
    },
    routeChildren() {
      const { children } = this.routeConfig;

      if (!children) {
        return [];
      }

      return children;
    },
    routeConfig() {
      const { routeName } = this;

      if (!routeName) {
        throw new Error(`"routeName" must be specified as a prop`);
      }

      const routeConfig = searchRouteListRecursive(this.$router.options.routes);

      if (!routeConfig) {
        throw new Error(`No routeConfig found for routeName "${routeName}"`);
      }

      return routeConfig;

      function searchRouteListRecursive(routeList) {
        for (let i = 0; i < routeList.length; i++) {
          const route = routeList[i];
          const { children, name } = route;

          if (routeName === name) {
            return route;
          }

          if (!children) {
            continue;
          }

          const match = searchRouteListRecursive(children);

          if (match) {
            return match;
          }
        }
      }
    },
    routeTitle() {
      return this.routeConfig.meta.title;
    },
  },
  data() {
    return {
      drawer: true,
    };
  },
  props: {
    routeName: {
      type: String,
      required: true,
    },
  },
};
</script>
